import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initTelegramApp } from './utils/telegram';
import { TonConnectUIProvider } from '@tonconnect/ui-react';

// Инициализируем Telegram WebApp
initTelegramApp();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <TonConnectUIProvider manifestUrl="https://your-app-domain.com/tonconnect-manifest.json">
      <App />
    </TonConnectUIProvider>
  </React.StrictMode>
);